import { getExecutableSaveDamageDefinitionForSpell, supportsSaveDamageActivation } from '../../../shared/rules/effects/saveDamageDefinitions.mjs';
import { getClassCastingProfile } from '../../../shared/rules/classSpellcasting.mjs';
import { saveDamageDiceGroups } from '../../../shared/rules/effects/saveDamagePresentation.mjs';

export const isAuthoritativeSaveDamageAccess = (spell, registry) => Boolean(
  typeof spell?.spellInstanceId === 'string' && spell.spellInstanceId.trim()
  && typeof spell.source?.sourceId === 'string'
  && (spell.source.sourceType === 'monster' || (spell.source.sourceType === 'class' && getClassCastingProfile(spell.source.sourceId))
    // Class-feature cantrips (Blessed Warrior Sacred Flame) cast with their class's profile.
    || (spell.source.sourceType === 'class-feature' && getClassCastingProfile(spell.source.classId)))
  && supportsSaveDamageActivation(getExecutableSaveDamageDefinitionForSpell(spell.spellId, registry))
  // Ice Knife's burst follows its attack, and Delayed Blast's bead its cast: neither is cast this way.
  && getExecutableSaveDamageDefinitionForSpell(spell.spellId, registry)?.actionCost?.resource !== 'free'
  && !getExecutableSaveDamageDefinitionForSpell(spell.spellId, registry)?.grantedBuff
);

/** Roll every prepared component together; preserve evidence by component index. */
export const rollSaveDamageEvidence = async (components, rollDice) => {
  const groups = saveDamageDiceGroups(components);
  const result = await rollDice(groups);
  const evidence = groups.map(({ count, sides }, index) => {
    const dice = result?.rolls?.[index];
    return Array.isArray(dice) && dice.length === count && dice.every((die) => Number.isInteger(die) && die >= 1 && die <= sides)
      ? [...dice] : null;
  });
  if (evidence.some((dice) => !dice)) throw new Error('Damage dice evidence was unavailable. Retry this resolution.');
  return evidence;
};
